import { object, string, array } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  evt_id: string().required(),
  remove: array().of(string().required()).required(),
});

/**
 * ClientUnsubscribeEvent
 *
 * - Esse evento é enviado pelo cliente para iniciar a conexão com o servidor.
 * - O cliente deve enviar esse evento assim que a conexão for estabelecida.
 * - O servidor irá responder com um evento de `SystemSubscribe` contendo informações sobre a conexão.
 */
export class ClientUnsubscribeEvent extends CreateCommand(
  RealtimeEventType.ClientUnsubscribe,
  SCHEMA,
) {}
